import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const ListPrestasi = () => {
  const [prestasi, setPrestasi] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const fetchPrestasi = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}api/prestasi`
      );
      setPrestasi(res.data);
    } catch (err) {
      toast.error("Gagal memuat prestasi.");
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Yakin ingin menghapus prestasi ini?")) return;
    try {
      await axios.delete(`${process.env.REACT_APP_API_URL}api/prestasi/${id}`);
      toast.success("Prestasi dihapus.");
      fetchPrestasi(); // refresh
    } catch (err) {
      toast.error("Gagal menghapus prestasi.");
    }
  };

  useEffect(() => {
    fetchPrestasi();
  }, []);

  return (
    <div className="min-h-screen bg-gray-100 p-6">
      <ToastContainer />
      <div className="max-w-6xl mx-auto">
        <h2 className="text-2xl font-semibold mb-6 text-center">
          Daftar Prestasi
        </h2>

        {loading ? (
          <p className="text-center text-gray-600">Memuat...</p>
        ) : prestasi.length === 0 ? (
          <p className="text-center text-gray-500">Belum ada data prestasi.</p>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
            {prestasi.map((item) => (
              <div
                key={item._id}
                onClick={() => navigate(`/gambar/${item._id}`)}
                className="bg-white rounded shadow p-4 cursor-pointer hover:shadow-md transition"
              >
                <img
                  src={`${process.env.REACT_APP_API_URL}api/prestasi/gambar/${item.gambar?.filename}`}
                  alt="Prestasi"
                  className="w-full h-48 object-cover rounded mb-2"
                />
                <h3 className="font-semibold text-lg mb-1">{item.judul}</h3>
                <p className="text-sm text-gray-600 mb-2">{item.deskripsi}</p>
                <button
                  onClick={(e) => {
                    e.stopPropagation(); // agar tidak trigger navigasi
                    handleDelete(item._id);
                  }}
                  className="text-red-600 text-sm hover:underline"
                >
                  Hapus
                </button>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default ListPrestasi;
